<template>
<v-container fluid fill-height>
    <v-layout justify-center>
        <v-responsive max-width="1024px" width="100%" height="100%">
            <v-row class="mt-4">
                <v-col cols="12" md="6">
                    <v-card>
                        <v-toolbar color="info lighten-1" dense>
                            <v-toolbar-title class="white--text subtitle-2">카테고리</v-toolbar-title>

                            <v-spacer></v-spacer>
                            <v-dialog v-model="dialog" width="560">
                                <template v-slot:activator="{ on }">
                                    <v-fab-transition>
                                        <v-btn color="accent" fab dark small absolute bottom right v-on="on">
                                            <v-icon>mdi-plus</v-icon>
                                        </v-btn>
                                    </v-fab-transition>
                                </template>

                                <v-card v-if="dialog">
                                    <v-card-title class="subtitle-1" primary-title>신규 카테고리 등록</v-card-title>

                                    <v-card-text>
                                        <v-row class="mt-3">
                                            <v-col class="py-0">
                                                <shop-category-select ref="shopCategorySelect" v-model="editItem._parent" :categories="categories"></shop-category-select>
                                            </v-col>
                                        </v-row>
                                        <v-row class="mt-6">
                                            <v-col class="py-0">
                                                <v-text-field v-model="editItem.name" label="카테고리 이름" placeholder=" " dense hide-details></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row class="mt-6">
                                            <v-col class="py-0">
                                                <v-text-field v-model="editItem.code" label="카테고리 코드" placeholder=" " dense hide-details></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row class="mt-6">
                                            <v-col class="py-0">
                                                <v-file-input v-model="editItem.icon" label="카테고리 아이콘" placeholder=" " dense hide-details append-icon="mdi-pencil"></v-file-input>
                                            </v-col>
                                        </v-row>

                                        <v-row align="center" class="mt-3">
                                            <v-col cols="auto"><span>검색엔진최적화(SEO)</span> <span>(사용/미사용)</span></v-col>
                                            <v-spacer/>
                                            <v-col cols="auto">
                                                <v-switch v-model="editItem.seoEnabled" dense hide-details class="pa-0 ma-0"></v-switch>
                                            </v-col>
                                        </v-row>
                                        <v-row v-if="editItem.seoEnabled">
                                            <v-col cols="12" class="py-3 py-md-0">
                                                <v-text-field v-model="editItem.seo.title" label="타이틀: Title" placeholder=" " dense hide-details class="mt-3" @input="input"></v-text-field>
                                            </v-col>
                                            <v-col cols="12" class="py-3 py-md-0">
                                                <v-text-field v-model="editItem.seo.meta.find((meta) => meta.name == 'author').content" label="메타태그: Author" placeholder=" " dense hide-details class="mt-6" @input="input"></v-text-field>
                                            </v-col>
                                            <v-col cols="12" class="py-3 py-md-0">
                                                <v-textarea v-model="editItem.seo.meta.find((meta) => meta.name == 'description').content" label="메타태그: Description" placeholder=" " dense hide-details class="mt-6" @input="input"></v-textarea>
                                            </v-col>
                                            <v-col cols="12" class="py-3 py-md-0">
                                                <v-textarea v-model="editItem.seo.meta.find((meta) => meta.name == 'keywords').content" label="메타태그: Keywords" placeholder=" " dense hide-details class="mt-6" @input="input"></v-textarea>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn text @click="dialog = false">취소</v-btn>
                                        <v-btn color="primary" text @click="save">등록</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-toolbar>

                        <v-card-text>
                            <v-draggable-treeview v-if="categories.length" v-model="categories" item-key="_id" children="children" group="categories" @click="change" dense></v-draggable-treeview>
                            <span v-else>등록된 카테고리가 없습니다.<br>카테고리를 등록해주세요</span>
                        </v-card-text>

                    </v-card>

                    <v-row>
                        <v-spacer></v-spacer>
                        <v-col md="auto">

                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="12" md="6">
                    <v-card :disabled="!category._id">
                        <v-card-title class="subtitle-1">카테고리 기본정보</v-card-title>
                        <v-card-text>
                            <v-row class="mt-3">
                                <v-col class="py-0">
                                    <v-text-field v-model="category.code" label="카테고리 코드(영문)" placeholder=" " dense hide-details></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row class="mt-6">
                                <v-col class="py-0">
                                    <v-text-field v-model="category.name" label="카테고리 이름" placeholder=" " dense hide-details></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row class="mt-6" align="center">
                                <v-col cols="auto" class="py-0">
                                        <v-img v-if="createObjectURL(category.icon)" :src="createObjectURL(category.icon)" color width="96" height="96"></v-img>
                                        <v-responsive v-else width="96" height="96">
                                            <v-row class="fill-height ma-0 grey lighten-3" align="center" justify="center">
                                                <v-icon>mdi-image</v-icon>
                                            </v-row>
                                        </v-responsive>
                                </v-col>
                                <v-col class="py-0 pl-0">
                                    <v-file-input v-model="category.icon" label="카테고리 아이콘" placeholder=" " dense hide-details></v-file-input>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>

                    <v-card class="mt-4" :disabled="!category._id">
                        <v-card-title>
                            <v-row>
                                <v-col cols="auto" class="subtitle-1 py-0">카테고리 배너</v-col>
                                <v-spacer/>
                                <v-col cols="auto" class="py-0">
                                    <v-btn color="primary" small>다른 카테고리에서 복사</v-btn>
                                </v-col>
                            </v-row>
                        </v-card-title>
                        <v-card-text>
                            <v-list class="pt-0">
                                <template v-for="(banner, index) in (category.banners || []).filter(banner => banner).reduce((adapter, banner) => { return [...adapter, banner, { divider: true }]}, [])">
                                    <v-divider v-if="banner.divider" :key="index"></v-divider>
                                    <v-list-item v-else :key="index">
                                        <v-list-item-content>
                                            <label style="display: inline-block; width: 100%; height: 56px">
                                                <v-row class="fill-height ma-0 grey lighten-2" align="center">
                                                    <v-img v-if="createObjectURL(banner)" :src="createObjectURL(banner)" width="100%" max-height="56" contain></v-img>
                                                    <v-responsive v-else width="100%" height="100%">
                                                        <v-row class="fill-height" align="center" justify="center">
                                                            <v-icon>mdi-image</v-icon>
                                                        </v-row>
                                                    </v-responsive>
                                                    <v-file-input v-show="false" v-model.lazy="category.banners[category.banners.indexOf(banner)]" label="배너 업로드" show-size accept="image/*"></v-file-input>
                                                </v-row>
                                            </label>
                                        </v-list-item-content>
                                        <v-list-item-action>
                                            <v-icon small @click="removeBanner(banner)">mdi-delete</v-icon>
                                        </v-list-item-action>
                                    </v-list-item>
                                </template>
                            </v-list>
                            <v-row align="center">
                                <v-col>
                                    <v-file-input v-model.lazy="banner" label="배너 업로드" placeholder=" " dense hide-details show-size accept="image/*" ></v-file-input>
                                </v-col>
                                <v-col cols="auto">
                                    <v-btn small color="primary" @click="insertBanner(banner)">추가</v-btn>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>

                    <v-card class="mt-4" :disabled="!category._id">
                        <v-card-title>
                            <v-row>
                                <v-col cols="auto" class="subtitle-1 py-0">카테고리 픽업</v-col>
                                <v-spacer/>
                                <v-col cols="auto" class="py-0">
                                    <v-btn color="primary" small>다른 카테고리에서 복사</v-btn>
                                </v-col>
                            </v-row>
                        </v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12" class="pt-0">
                                    <v-list class="pt-0">
                                        <template v-for="(pickup, index) in (category.pickups || []).reduce((adapter, pickup) => { return [...adapter, pickup, { divider: true }]}, [])">
                                            <v-divider v-if="pickup.divider" :key="index"></v-divider>
                                            <v-list-item v-else :key="index">
                                                <v-list-item-avatar>
                                                    <v-img v-if="pickup.thumb" :src="pickup.thumb" width="56" height="56" contain></v-img>
                                                </v-list-item-avatar>
                                                <v-list-item-content>
                                                    <v-list-item-title>{{ pickup.name }}</v-list-item-title>
                                                </v-list-item-content>
                                                <v-list-item-action>
                                                    <v-icon small @click="removePickup(pickup)">mdi-delete</v-icon>
                                                </v-list-item-action>
                                            </v-list-item>
                                        </template>
                                    </v-list>
                                </v-col>
                                <v-col class="py-0">
                                    <product-autocomplete v-model="pickup" label="상품검색" placeholder=" " dense hide-details></product-autocomplete>
                                </v-col>
                                <v-col cols="auto" class="py-0 pl-0">
                                    <v-btn color="primary" small @click="insertPickup(pickup)">추가</v-btn>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>

                    <shop-category-seo v-model="category" :disabled="!category._id"></shop-category-seo>

                    <v-row>
                        <v-col md="auto">
                            <v-btn color="grey darken-1" class="white--text" @click="remove(category)" :disabled="!category._id || category.root ? true : false">삭제</v-btn>
                        </v-col>
                        <v-spacer></v-spacer>
                        <v-col md="auto">
                            <v-btn color="primary" @click="update(category)" :disabled="!category._id">저장</v-btn>
                        </v-col>
                    </v-row>

                </v-col>
            </v-row>
        </v-responsive>
    </v-layout>

</v-container>
</template>

<script>
import api from "@/api";
import ShopCategorySelect from '@/components/console/shop/categories/shop-category-select.vue';
import ShopCategorySeo from '@/components/console/shop/categories/shop-category-seo.vue';
import ProductAutocomplete from "@/components/console/shop/products/product-autocomplete.vue";

export default {
    components: {
        ShopCategorySelect,
        ShopCategorySeo,
        ProductAutocomplete
    },
    data() {
        return {
            dialog: false,

            loading: true,

            headers: [],
            categories: [],
            category: {
                banners: []
            },
            editItem: null,
            defaultItem: {
                _parent: null,
                name: "",
                no: 0,
                type: "",
                icon: null,
                _pickups: [],
                banners: [],
                seoEnabled: false,
                seo: {
                    title: null,
                    meta: [
                        { name: "author", content: null },
                        { name: "description", content: null },
                        { name: "keywords", content: null },
                    ]
                }
            },

            banner: null,
            pickup: null
        };
    },
    mounted(){
        this.init();
    },
    methods: {
        async init(){
            await this.search();
            this.loading = false;
        },

        async search(){
            try{
                var { categories } = await api.console.shop.categories.getCategories();
                this.categories = categories;
            }
            catch(error){
                console.error(error);
                alert(error.response ? error.response.data.message : error.message );
            }
        },

        async change(category){
            try{
                if(category.icon && !this.createObjectURL(category.icon)) category.icon = await api.getResource(category.icon);
                for(var index in category.banners){
                    if(category.banners[index] && !this.createObjectURL(category.banners[index])) category.banners[index] = await api.getResource(category.banners[index]);
                }
            }
            catch(error){
                console.error(error);
                // alert(error.response ? error.response.data.message : error.message);
            }
            this.category = category;
        },

        /////////////////////////////////////////
        // 카테고리 등록
        /////////////////////////////////////////
        async save() {
            try {
                this.loading = true;

                var { category } = await api.console.shop.categories.postCategory(
                    Object.assign({}, this.editItem, {
                        _parents: this.editItem._parent ? [...this.$refs.shopCategorySelect.category._parents, this.editItem._parent] : [],
                        depth: this.editItem._parent ? this.$refs.shopCategorySelect.category.depth + 1 : 1,
                    })
                );

                // 카테고리 아이콘 저장
                if(category.icon) await api.console.shop.categories.postIcon({ _id: category._id, ...this.editItem });
                
                // 카테고리 배너 저장
                for(var index in category.banners){
                    if(category.banners[index]) await api.console.shop.categories.postBanner(category, index);
                }
                
                alert("저장되었습니다");
                await this.search();
                this.dialog = false;
            } catch (error) {
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },

        /////////////////////////////////////////
        // 카테고리 수정
        /////////////////////////////////////////
        async update(category) {
            try {
                this.loading = true;

                await api.console.shop.categories.putCategory(category);
                if(category.icon) await api.console.shop.categories.postIcon(category);

                for(let index in category.banners){
                    if(!category.banners[index]) await api.console.shop.categories.deleteBanner(category, index);
                }

                for(let index in category.banners.filter(banner => banner)){
                    await api.console.shop.categories.postBanner(category, index);
                }

                alert("저장되었습니다");
                await this.search();
            } catch (error) {
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },

        /////////////////////////////////////////
        // 카테고리 삭제
        /////////////////////////////////////////
        async remove(category) {
            try {
                this.loading = true;

                await api.console.shop.categories.deleteCategory(category);
                await this.search();
            } catch (error) {
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },

        sort(categories, _parents = [], depth = 1) {
            for(var category of categories) {
                category.sequence = categories.indexOf(category);
                category.depth = depth;
                category._parents = _parents;

                if (category.children) {
                    category._children = category.children.map((child) => { return child._id });
                    this.sort(category.children, [].concat(category._parents, category._id), depth + 1);
                }
                api.console.shop.categories.putCategory(category);
            }
        },

        insertBanner(banner){
            this.category.banners.push(banner);
        },

        removeBanner(banner){
            this.category.banners.splice(this.category.banners.indexOf(banner), 1);
            this.category.banners.push(undefined);
        },

        insertPickup(pickup){
            this.category.pickups.push(pickup);
            this.category._pickups.push(pickup._id);
        },

        removePickup(pickup){
            this.category.pickups.splice(this.category.pickups.findIndex(item => item._id == pickup._id), 1);
            this.category._pickups.splice(this.category._pickups.findIndex(item => item == pickup._id), 1);
        },

        createObjectURL(file){
            try{
                return URL.createObjectURL(file);
            }
            catch(error){
                return null;
            }
        }
    },
    watch: {
        dialog(value){
            if(value) this.editItem = Object.assign({}, this.defaultItem);
        },
        categories() {
            if(!this.loading) this.sort(this.categories);
        }
    }
}
</script>
